import { motion } from 'framer-motion'
import { TrendingUp, Target, PieChart, BarChart3, Clock, CheckCircle } from 'lucide-react'
import FeatureLayout from '../../components/FeatureLayout'
import { useLanguage } from '../../contexts/LanguageContext'

export default function HabitsScorePage() {
  const { t } = useLanguage()

  return (
    <FeatureLayout
      title={t('habitsScore.modal.title')}
      subtitle={t('habitsScore.modal.subtitle')}
      gradientFrom="from-green-500"
      gradientTo="to-emerald-500"
      icon={<TrendingUp className="h-10 w-10 text-white" />}
      featureName="Money Habits Score"
    >
      {/* What Is Section */}
      <section className="mb-16">
        <div className="bg-gradient-to-r from-green-500/10 to-emerald-500/10 rounded-3xl p-8 lg:p-12 border border-green-500/20">
          <div className="flex items-start gap-6">
            <div className="p-4 bg-green-500/20 rounded-2xl">
              <Target className="h-8 w-8 text-green-400" />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-white mb-4">{t('habitsScore.modal.whatIs')}</h2>
              <p className="text-gray-300 text-lg leading-relaxed">{t('habitsScore.modal.intro')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Score Components */}
      <section className="mb-16">
        <h2 className="text-3xl font-bold text-white mb-8">{t('habitsScore.modal.components')}</h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: Target, title: t('habitsScore.modal.savings'), weight: t('habitsScore.modal.weight30') },
            { icon: BarChart3, title: t('habitsScore.modal.spending'), weight: t('habitsScore.modal.weight25') },
            { icon: PieChart, title: t('habitsScore.modal.budgeting'), weight: t('habitsScore.modal.weight25') },
            { icon: Clock, title: t('habitsScore.modal.planning'), weight: t('habitsScore.modal.weight20') },
          ].map((component, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-white/5 rounded-2xl p-6 border border-green-500/20 text-center"
            >
              <div className="w-14 h-14 bg-green-500/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <component.icon className="h-7 w-7 text-green-400" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{component.title}</h3>
              <p className="text-green-400 font-semibold">{component.weight}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section>
        <div className="bg-gradient-to-r from-green-600/20 to-emerald-600/20 rounded-3xl p-8 lg:p-12 border border-green-500/30 text-center">
          <CheckCircle className="h-16 w-16 text-green-400 mx-auto mb-6" />
          <h2 className="text-3xl font-bold text-white mb-4">{t('habitsScore.modal.cta')}</h2>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            {t('habitsScore.modal.ctaDescription')}
          </p>
          <a
            href="/#waitlist"
            className="inline-block px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white font-semibold rounded-xl transition-all transform hover:scale-105"
          >
            Join Waitlist Now
          </a>
        </div>
      </section>
    </FeatureLayout>
  )
}
